export default {
  searching: 'Suche läuft',
}
